import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    EventGuestListWrapperQuery,
    EventGuestListWrapperQueryVariables,
} from './GuestList.queries.generated'

export const GET_EVENT_GUEST_LIST_WRAPPER: TypedDocumentNode<
    EventGuestListWrapperQuery,
    EventGuestListWrapperQueryVariables
> = gql`
    query EventGuestListWrapper($guid: String!) {
        viewer {
            guid
            user {
                guid
            }
        }
        entity(guid: $guid) {
            guid
            ... on Event {
                title
                startDate
                endDate
                isAttending
                attendees(
                    limit: 3
                    state: "accept"
                    orderBy: timeUpdated
                    orderDirection: desc
                ) {
                    total
                    totalAccept
                    totalCheckedIn
                    totalAcceptNotCheckedIn
                    totalWaitinglistNotCheckedIn
                    edges {
                        guid
                        name
                        state
                        url
                        icon
                    }
                }
                url
                canEdit
            }
        }
    }
`
